module.exports = __webpack_public_path__ + "static/media/company.53b53a0f.svg";